Customer.Dashboard ||= {}

class Customer.Dashboard.SummarySearchView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/summary/main/header/summary_search"]

  render: (filter) ->
    @search_text = filter.attributes.query.search_text
    @$el.html(@template(filter: filter.attributes))
    @$el.find('#search').on('click', @onSearchText)
    @$el.find('#search_loading').on('click', @onCancelSearch)
    @$el.find('#search_text').on('keypress', @onSearchTextKeypress)
    @$el.find('#search_text').on('change', @onSearchTextChange)
    @$el.find('.search-clear').on('click', @onClearSearch)
    @

  onCancelSearch: (event) =>
    @searchFinished()
    @trigger('search:settings:cancelled')

  onSearchText: (event) =>
    @showSearchSpinner()
    @disableSearchInput()
    @search_text = @$el.find('#search_text').val().trim()
    @trigger('search:settings:changed', @search_text)

  onWritingText: (event) =>
    @search_text = @$el.find('#search_text')
    if (@search_text.val().length > 0)
      @search_text.nextAll('.search-clear').removeClass('d-none')
    else if (@search_text.val().length == 0)
      @search_text.nextAll('.search-clear').addClass('d-none')

  onSearchTextKeypress: (event) =>
    if event.which is 13 #Enter key
      @onSearchText(event)

  onSearchTextChange: (event) =>
    @onWritingText(event)

  onClearSearch: (event) =>
    @showSearchSpinner()
    @disableSearchInput()
    @$el.find('.search-clear').addClass('d-none').prevAll(':input').val('')
    @trigger('search:settings:changed', '')

  getSearchText: ->
    @search_text || ''

  show: () ->
    @$el.css(display: 'block')

  hide: () ->
    @$el.css(display: 'none')

  hideSearchSpinner: ->
    @$el.find('#search_loading').addClass('d-none')
    @$el.find('#search').removeClass('d-none')

  showSearchSpinner: ->
    @$el.find('#search_loading').removeClass('d-none')
    @$el.find('#search').addClass('d-none')

  searchFinished: ->
    @hideSearchSpinner()
    @enableSearchInput()

  disableSearchInput: ->
    @$el.find('#search_text').prop('disabled', true)
    @$el.find('.search-clear').addClass('d-none')

  enableSearchInput: ->
    @$el.find('#search_text').prop('disabled', false)
    @onWritingText()

